import * as React from 'react';
import { ConsentService } from '../../services';
import { SwitchControl } from '../controls';

export interface IMijnFNVConsentBlockProps {
  title: string;
  description?: string;
  consentId: string;
  consent: boolean;
}

/**
 * Displays a consent block for managing consent on the given item
 * @param props 
 * @returns 
 */
export const MijnFNVConsentBlock = (props: IMijnFNVConsentBlockProps) => {
  const id = `consent-${props.consentId}`;

  const handleConsentChange = async (value: boolean) => {
    if (value) {
      await ConsentService.accept(props.consentId);
    } else {
      await ConsentService.revoke(props.consentId);
    }
  };

  return (
    <>
      <div className="row border-top py-3 align-items-center">
        <div className="col-10">
          <p className="mb-0">
            <strong>{props.title}
            </strong>
          </p>
          <p className="mb-0">
            {props.description}
          </p>
        </div>
        <div className="col-2 text-right">
          <SwitchControl
            checked={props.consent}
            id={id}
            onChange={handleConsentChange}
          />
        </div>
      </div>
    </>
  );
};
